import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CompanyProfileService } from './company-profile.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private readonly companyProfile = inject(CompanyProfileService);
  private currencyCode$ = new BehaviorSubject<string>('EUR');
  private currencySymbol$ = new BehaviorSubject<string>('€');
  private loaded = false;

  loadCurrency(): void {
    if (this.loaded) return;

    this.companyProfile.getSettings().subscribe({
      next: (response) => {
        if (response?.success && response.data) {
          const code = response.data['currency_code'] || 'EUR';
          const symbol = response.data['currency_symbol'] || code;
          this.currencyCode$.next(code);
          this.currencySymbol$.next(symbol);
          this.loaded = true;
        }
      },
      error: () => {
        this.loaded = true;
      }
    });
  }

  /** ISO 4217 code (e.g. USD, EUR, UAH) — for Angular CurrencyPipe and PrimeNG */
  getCurrency(): string {
    return this.currencyCode$.value;
  }

  getCurrency$(): Observable<string> {
    return this.currencyCode$.asObservable();
  }

  /** Display symbol (e.g. $, €, ₴) — for raw string formatting */
  getCurrencySymbol(): string {
    return this.currencySymbol$.value;
  }

  getCurrencySymbol$(): Observable<string> {
    return this.currencySymbol$.asObservable();
  }

  clearCache(): void {
    this.currencyCode$.next('EUR');
    this.currencySymbol$.next('€');
    this.loaded = false;
  }

  reloadCurrency(): void {
    this.loaded = false;
    this.loadCurrency();
  }
}
